import script from "./ResourceCenterView.vue?vue&type=script&setup=true&lang=js"
export * from "./ResourceCenterView.vue?vue&type=script&setup=true&lang=js"

import "./ResourceCenterView.vue?vue&type=style&index=0&id=302d01d9&lang=css"

const __exports__ = script;

export default __exports__